module.exports = __webpack_public_path__ + "static/media/Farming_where_it_doesnt_rain_tablet.65da7852.png";